export default {"src":"/_next/static/media/0xb3654dc3d10ea7645f8319668e8f54d2574fbdc8.bc433701.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};